module.exports = __webpack_public_path__ + "static/media/blanka-lipstick-your-logo.905b9b59.png";